export enum ChartBulletTypesEnum {
    CIRCLE = 'CIRCLE',
    RIGHT_ARROW = 'RIGHT_ARROW'
}
